/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_No_Finals_In_ProgressInputs */



/**
* | output |
* | --- |
* | "No finals in progress" |
*
* @param {Err_Tournament_No_Finals_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_no_finals_in_progress = /** @type {((inputs?: Err_Tournament_No_Finals_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_No_Finals_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune finale en cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna final en progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma final em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna finale in corso")
	return /** @type {LocalizedString} */ ("No finals in progress")
});